import { render } from "./SolicitudReceta.vue?vue&type=template&id=13dc6b10"
import script from "./SolicitudReceta.vue?vue&type=script&lang=js"
export * from "./SolicitudReceta.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__